import Account from '@/orm/models/Account/Account';
import { computed, ref } from '@vue/composition-api';

import { useI18n } from 'vue-i18n-composable';
import moment from 'moment';
import { quotaItemTypes } from '@/enums';

// TODO: убрать мок
const mock = {
  data: {
    id: 1,
    subscriptionEnabled: true,
    plan: {
      id: 2,
      quotas: [{ itemType: 'interviews', type: 'temp', value: 50 }, { itemType: 'calls', type: 'temp', value: 250 }, { itemType: 'sms', type: 'temp', value: 250 }],
      price: {
        id: 6, value: 100, currency: 'USD', currencyName: 'US Dollar',
      },
      title: 'Small business',
      description: null,
      active: false,
    },
    planPrice: {
      id: 6, value: 100, currency: 'USD', currencyName: 'US Dollar',
    },
    period: {
      id: 3, duration: 6, default: false, discountPercent: 10,
    },
    nextPlan: null,
    nextPeriod: null,
    expirationDate: '2021-11-13T18:33:54+00:00',
    startDate: '2021-05-13T18:33:54+00:00',
    quota: { accountId: 1, quotas: { interviews: 70, calls: 300, sms: 300 } },
    periodEnd: '2021-06-13T18:33:54.000000Z',
    periodStart: '2021-05-13T18:33:54.000000Z',
    active: true,
    next: {
      paymentDate: '2021-11-12T18:33:54.000000Z',
      paymentPrice: {
        id: 6, value: 100, currency: 'USD', currencyName: 'US Dollar',
      },
      paymentPriceWithDiscount: {
        id: null, value: 90, currency: 'USD', currencyName: 'US Dollar',
      },
      paymentPeriod: {
        id: 3, duration: 6, default: false, discountPercent: 10,
      },
    },
  },
};

const fetchStatusKey = 'current';
let fetchPromise = null;

export default function useAccount() {
  const account = computed(() => Account.query().withAllRecursive().first());
  const { locale } = useI18n();

  async function fetch() {
    if (fetchPromise) {
      return fetchPromise;
    }

    fetchPromise = Account.handleFetching(async function fetchCurrent() {
      try {
        return await this.api().fetch();
      } catch (e) {
        return this.create(mock);
      }
    }, fetchStatusKey);

    return fetchPromise.finally(() => {
      fetchPromise = null;
    });
  }

  async function fetchIfNull() {
    const fetchStatus = Account.getFetchStatus(fetchStatusKey);
    if (account.value || fetchStatus.isFetching) {
      return;
    }
    await fetch();
  }

  const periodText = computed(() => {
    const { periodEnd, periodStart } = account.value;

    const startText = moment(periodStart)
      .locale(locale.value.toLowerCase()).format('LL');

    const endText = moment(periodEnd)
      .locale(locale.value.toLowerCase()).format('LLL');
    return `${startText} - ${endText}`;
  });

  const endPeriodText = computed(() => {
    const { periodEnd } = account.value;
    return moment(periodEnd)
      .locale(locale.value.toLowerCase()).format('LLL');
  });

  const leftDays = computed(() => {
    const { periodEnd } = account.value;
    return moment(periodEnd).diff(Date.now(), 'days');
  });

  const nextPaymentText = computed(() => {
    const { paymentDate } = account.value.next;
    return moment(paymentDate)
      .locale(locale.value.toLowerCase()).format('LLL');
  });

  const nextPlanText = computed(() => {
    return account.value?.nextPlan ? account?.value.nextPlan?.title : account.value?.plan?.title;
  });

  const expirationText = computed(() => {
    const { expirationDate } = account.value;
    return moment(expirationDate)
      .locale(locale.value.toLowerCase()).format('LLL');
  });
  const quota = computed(() => {
    return account.value?.quota.quotas || [];
  });

  const period = computed(() => {
    return account.value?.period;
  });

  const nextPlan = computed(() => {
    return account.value?.nextPlan;
  });

  const plan = computed(() => {
    return account.value?.plan;
  });

  const hasActivePaymentMethod = computed(() => account.value?.hasActivePaymentMethod);

  function cancelNextPlan(cancelPlan, cancelPeriod) {
    return Account.api().cancelNextPlan(cancelPlan, cancelPeriod);
  }

  function checkIfQuotaCanBeAdded(quota) {
    const addableQuotas = [
      quotaItemTypes.CALLS,
      quotaItemTypes.SMS,
    ];

    return addableQuotas.includes(quota);
  }

  async function startTrial(payload) {
    await Account.api().startTrial(payload);
  }

  return {
    account,
    fetch,
    fetchIfNull,
    plan,
    nextPlan,
    periodText,
    endPeriodText,
    nextPaymentText,
    leftDays,
    nextPlanText,
    quota,
    period,
    expirationText,
    hasActivePaymentMethod,
    cancelNextPlan,
    checkIfQuotaCanBeAdded,
    startTrial,
  };
}
